import React, { useEffect, useState } from 'react';
import { TimerIcon } from 'lucide-react';
const TOTAL_SECONDS = 10 * 60 + 21;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function CountdownBar() {
  const [remaining, setRemaining] = useState<number>(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const units = [{
    value: Math.floor(remaining / 60),
    suffix: 'Min'
  }, {
    value: remaining % 60,
    suffix: 'Sek'
  }];
  return <div className="sticky top-0 z-50 w-full bg-navy-deep text-white" data-id="element-54" data-mp="2cgz7755fetir">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-3 whitespace-nowrap px-4 py-2 text-xs font-semibold sm:text-sm" data-id="element-55" data-mp="28f45hzjl2e4g">
        <TimerIcon className="h-4 w-4 shrink-0 text-sun" aria-hidden="true" data-id="element-56" data-mp="ao1lrudzb37u" />
        <span data-id="element-57" data-mp="6oakuxuqn6pl">Das Sonderangebot endet in:</span>
        <span className="flex items-center gap-1.5 tabular-nums" aria-live="off" data-id="element-58" data-mp="6lem57b2ge03">
          {units.map((unit, index) => <span key={unit.suffix} className="flex items-center gap-1.5" data-id="element-59" data-mp="18dn04g2nbifz" data-mpi={index}>
              <span className="flex items-baseline gap-1 rounded-md bg-sun px-2 py-0.5 text-navy" data-id="element-60" data-mp="udc6x6dv5rrn">
                <span className="font-display text-sm font-extrabold sm:text-base" data-id="element-61" data-mp="yexrzf0jxccx">
                  {pad(unit.value)}
                </span>
                <span className="text-[10px] font-bold" data-id="element-62" data-mp="1m5jny7xa766k">{unit.suffix}</span>
              </span>
              {index < units.length - 1 && <span className="font-bold text-sun" data-id="element-63" data-mp="1r2tke7j38i3w">:</span>}
            </span>)}
        </span>
      </div>
    </div>;
}